import {css} from "@panda/css";

// The host modal renders no paddings around a step - each step brings its own
export const reservationStepContentStyle = css({
    display: "flex",
    flexDirection: "column",
    rowGap: 2,
    px: 2,
    pt: 1,
    pb: 3,
    md: {
        px: 3
    }
});

// a step built around an illustration or an icon - the confirmation and the failure notice
export const reservationStepCenteredContentStyle = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    rowGap: 3,
    px: 2,
    pt: 3,
    pb: 3,
    md: {
        px: 3
    }
});

// full width also inside a centered step
export const reservationStepTextStyle = css({
    display: "flex",
    flexDirection: "column",
    rowGap: 1,
    width: "100%"
});

export const reservationFocusRingStyle = css({
    _focusVisible: {
        outline: "2px solid var(--colors-secondary)",
        outlineOffset: "2px"
    }
});
import {css} from "@panda/css";

// The host modal renders no paddings around a step - each step brings its own
export const reservationStepContentStyle = css({
    display: "flex",
    flexDirection: "column",
    rowGap: 2,
    px: 2,
    pt: 1,
    pb: 3,
    md: {
        px: 3
    }
});

// a step built around an illustration or an icon - the confirmation and the failure notice
export const reservationStepCenteredContentStyle = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    rowGap: 3,
    px: 2,
    pt: 3,
    pb: 3,
    md: {
        px: 3
    }
});

// full width also inside a centered step
export const reservationStepTextStyle = css({
    display: "flex",
    flexDirection: "column",
    rowGap: 1,
    width: "100%"
});

export const reservationFocusRingStyle = css({
    _focusVisible: {
        outline: "2px solid var(--colors-secondary)",
        outlineOffset: "2px"
    }
});
